module.exports = __webpack_public_path__ + "img/fgf.7fc48475.svg";